import React, { useMemo } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import {
  getFormDateTypeQuestions,
  getFormQuestionAttributeEndDateQuestionUuid,
  getFormQuestionAttributeStartDateQuestionUuid,
} from "reduxSlices/formBuilderSlice"
import { CURRENT_DATE } from "utils/dateDifferenceHelpers"
import FormsyValidation from "shared/FormsyValidation"

// The date selects only offer date questions, and a question one of them names
// can be neither deleted nor retyped, so this guards a form whose questions were
// not built through them.
const DatesResolveToDateQuestionsValidation = ({ sectionIndex, questionIndex }) => {
  const questionEndDateQuestionUuid = useSelector(getFormQuestionAttributeEndDateQuestionUuid({ sectionIndex, questionIndex }))
  const questionStartDateQuestionUuid = useSelector(getFormQuestionAttributeStartDateQuestionUuid({ sectionIndex, questionIndex }))
  const dateQuestions = useSelector(getFormDateTypeQuestions, isEqual)

  // A date that has not been chosen yet is left to NoBlankDatesValidation, so
  // that it is reported once rather than twice.
  const value = useMemo(
    () => {
      const dateQuestionUuids = dateQuestions.map(({ uuid }) => uuid)

      return [questionEndDateQuestionUuid, questionStartDateQuestionUuid]
        .filter(Boolean)
        .filter((uuid) => uuid !== CURRENT_DATE && !dateQuestionUuids.includes(uuid))
    },
    [questionEndDateQuestionUuid, questionStartDateQuestionUuid, dateQuestions],
  )

  return (
    <FormsyValidation
      name={`sections[${sectionIndex}].questions[${questionIndex}].datesResolveToDateQuestions`}
      value={value}
      validations={{
        datesResolveToDateQuestions(_model, val) {
          if (val?.length) return "Each date must be a date question on this form or the current date"
          return true
        },
      }}
    />
  )
}

DatesResolveToDateQuestionsValidation.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DatesResolveToDateQuestionsValidation
